import React from 'react';
import PropTypes from 'prop-types';

import {
  Chip,
} from '@material-ui/core';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { makeStyles } from '@material-ui/core/styles';

import {
  Alert,
} from '@material-ui/lab';

import {
  Close as CloseIcon,  
} from '@material-ui/icons';

import { 
  SnackbarAlert,
}                     from '../../utils/components';

import {
  closeExecution,
}                     from  '../hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '75px',
  },
}));


export default function ExecutionInputFeedStatus(props) {
  const { value: execution } = props;

  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [closeExecutionMessage, setCloseExecutionMessage] = React.useState({});
  const [showCloseExecutionMessage, setShowCloseExecutionMessage] = React.useState(false);
  
  const feedStatus = execution.Feed;
  const executionId = execution.ExecutionId;

  const classes = useStyles();

  const handleConfirmDialogOpen = () => {
    setConfirmDialogOpen(true);
  };
  
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleCloseCloseExecutionMessage = () => {
    setShowCloseExecutionMessage(false);
  };

  const handleCloseFeed = async () => {
    handleConfirmDialogClose();
    const { succeeded } = await closeExecution(executionId);
    if(succeeded) {
      setCloseExecutionMessage({ 
        message: "Execution close initiated.",
        severity: "success",
      });
    } else {
      setCloseExecutionMessage({ 
        message: "Unable to close execution!",
        severity: "error",
      });
    }
  };

  return(
    <React.Fragment>
      <Chip 
        className={classes.root}
        size="small"
        label={feedStatus}
        deleteIcon={feedStatus==='OPEN'?<CloseIcon/>:null}
        onDelete={feedStatus==='OPEN'?handleConfirmDialogOpen:null}
      />
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Close Execution Input Feed?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Closing the input feed will prevent additional inputs from being queued
            to this execution.  Inputs already queued for processing 
            will not be affected.
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            <Alert severity="warning">IMPORTANT: Once closed the feed cannot be re-opened.</Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCloseFeed} color="primary" autoFocus>
            Close Feed
          </Button>
        </DialogActions>
      </Dialog>
      <SnackbarAlert 
        key={'Close Execution'}
        open={showCloseExecutionMessage}
        onClose={handleCloseCloseExecutionMessage}
        {...closeExecutionMessage}
      />

    </React.Fragment>    
  );
}

ExecutionInputFeedStatus.propTypes = {
  value: PropTypes.any.isRequired,
};